import(/* webpackMode: "eager" */ "/home/rajat/Downloads/HR Shakti/frontend/src/app/(app)/learning/my-learning/page.tsx");
